import { useEffect, useState } from 'react';

const OPEN_PAY_ID = process.env.REACT_APP_OPEN_PAY_ID;
const OPEN_PAY_API_KEY = process.env.REACT_APP_OPEN_PAY_API_KEY;

console.log('OPEN_PAY_ID', OPEN_PAY_ID);
console.log('OPEN_PAY_API_KEY', OPEN_PAY_API_KEY);

export const useOpenpay = () => {
  const [deviceSessionId, setDeviceSessionId] = useState(null);

  useEffect(() => {
    window.OpenPay.setId(OPEN_PAY_ID);
    window.OpenPay.setApiKey(OPEN_PAY_API_KEY);

    if (process.env.NODE_ENV !== 'production') {
      window.OpenPay.setSandboxMode(true);
    }

    setDeviceSessionId(window.OpenPay.deviceData.setup());
  }, []);

  return {
    deviceSessionId,
  };
};
